// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: none;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  white-space: nowrap;
}

.anchor-label {
  font-weight: 500;
  font-size: 12px;
  color: #666;
  pointer-events: none;
  white-space: nowrap;
  margin: 0;
  padding: 0;
}

.snapshot-selector {
  display: flex;
  align-items: center;
  height: 48px;
  white-space: nowrap;
}

.snapshot-select {
  appearance: none;
  -webkit-appearance: none;
  height: 48px !important;
  padding: 0 42px 0 20px !important;
  border: 1px solid var(--Colors-UI-Secondary-Secondary-Light, #CCDCE4) !important;
  border-radius: 16px !important;
  background-color: var(--Colors-UI-Neutral-Grey-0, #FFF);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  color: var(--Colors-UI-Status-Information-Information-Dark, #023650);
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400 !important;
  line-height: normal;
  font-family: 'Euclid Circular A', sans-serif !important;
  cursor: pointer;
  white-space: nowrap;
  min-width: 240px;
  box-sizing: border-box;
}

.snapshot-select option {
  font-family: 'Euclid Circular A', sans-serif;
  font-weight: 400;
}

.snapshot-select:hover {
  background-color: #F0F4F8;
}

.snapshot-select:active {
  background-color: #E0E8F0;
}

.snapshot-select:focus {
  outline: none;
  border-color: #4E758E;
}

.snapshot-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/snapshot-picker.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,iCAAiC;EACjC,gFAAgF;EAChF,8BAA8B;EAC9B,uDAAuD;EACvD,yDAA6C;EAC7C,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,oEAAoE;EACpE,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,uDAAuD;EACvD,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[":host {\n  display: none;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.anchor-label {\n  font-weight: 500;\n  font-size: 12px;\n  color: #666;\n  pointer-events: none;\n  white-space: nowrap;\n  margin: 0;\n  padding: 0;\n}\n\n.snapshot-selector {\n  display: flex;\n  align-items: center;\n  height: 48px;\n  white-space: nowrap;\n}\n\n.snapshot-select {\n  appearance: none;\n  -webkit-appearance: none;\n  height: 48px !important;\n  padding: 0 42px 0 20px !important;\n  border: 1px solid var(--Colors-UI-Secondary-Secondary-Light, #CCDCE4) !important;\n  border-radius: 16px !important;\n  background-color: var(--Colors-UI-Neutral-Grey-0, #FFF);\n  background-image: url('./img/arrow-down.svg');\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n  color: var(--Colors-UI-Status-Information-Information-Dark, #023650);\n  font-size: 16px !important;\n  font-style: normal;\n  font-weight: 400 !important;\n  line-height: normal;\n  font-family: 'Euclid Circular A', sans-serif !important;\n  cursor: pointer;\n  white-space: nowrap;\n  min-width: 240px;\n  box-sizing: border-box;\n}\n\n.snapshot-select option {\n  font-family: 'Euclid Circular A', sans-serif;\n  font-weight: 400;\n}\n\n.snapshot-select:hover {\n  background-color: #F0F4F8;\n}\n\n.snapshot-select:active {\n  background-color: #E0E8F0;\n}\n\n.snapshot-select:focus {\n  outline: none;\n  border-color: #4E758E;\n}\n\n.snapshot-select:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
